"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _svg = require("../../../../../configuration/svg");

var _creators = require("../../../../../redux/creators");

var _ChipView = require("../filters/ChipView");

var _ProductOverviewComponent = _interopRequireDefault(require("./ProductOverviewComponent"));

var _utils = require("../../../../../configuration/utils");

var _ExternalBanner = _interopRequireDefault(require("./ExternalBanner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ProductsList = function ProductsList(_ref) {
  var isAccessoriesList = _ref.isAccessoriesList;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      bannerProducts = _useState2[0],
      setBannerProducts = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      bannerHeight = _useState4[0],
      setBannerHeight = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = _slicedToArray(_useState5, 2),
      lazyLoad = _useState6[0],
      setLazyLoad = _useState6[1];

  (0, _react.useEffect)(function () {
    window.addEventListener('scroll', function () {
      return setLazyLoad(false);
    });
    var imageLoaded = setTimeout(function () {
      setLazyLoad(false);
    }, 10000);
    return function () {
      window.removeEventListener('scroll', function () {
        return setLazyLoad(false);
      });
      clearTimeout(imageLoaded);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (!lazyLoad) {
      window.removeEventListener('scroll', function () {
        return setLazyLoad(false);
      });
    }
  }, [lazyLoad]);
  var isOpenFilters = (0, _reactRedux.useSelector)(function (state) {
    return state.openFilters;
  });
  var isMobile = (0, _reactRedux.useSelector)(function (state) {
    return state.isMobile;
  });
  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });
  var products = (0, _reactRedux.useSelector)(function (state) {
    return state.activeProducts;
  });
  var selectedFilters = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedFilters;
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-list"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "marketing"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "marketing__header"
  }, isAccessoriesList ? dictionary['Accessories List Marketing Headline'] : dictionary['Hearing Aid List Marketing Headline']), /*#__PURE__*/_react["default"].createElement("h2", {
    className: "marketing__desc"
  }, isAccessoriesList ? dictionary['Accessories List Marketing Body'] : dictionary['Hearing Aid List Marketing Body'])), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mobile-filters",
    onClick: function onClick() {
      return dispatch((0, _creators.openFilters)((0, _utils.toggleLayerFunction)(!isOpenFilters)));
    }
  }, dictionary.filters, /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _svg.filtersSVG
    }
  })), /*#__PURE__*/_react["default"].createElement(_ChipView.ChipViewContainer, null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "products__count"
  }, isAccessoriesList ? dictionary['Accessories'] : dictionary['Hearing Aids'], ":", ' ', products ? products.length : ''), /*#__PURE__*/_react["default"].createElement("div", {
    className: bannerProducts ? 'products external-banner' : 'products'
  }, /*#__PURE__*/_react["default"].createElement(_ExternalBanner["default"], {
    bannerHeight: bannerHeight,
    setBannerHeight: setBannerHeight,
    products: products,
    setBannerProducts: setBannerProducts,
    isAccessoriesList: isAccessoriesList
  }), products.map(function (product, index) {
    if (bannerProducts && (index === 2 || index === 3)) {
      return null;
    }

    return /*#__PURE__*/_react["default"].createElement(_ProductOverviewComponent["default"], {
      product: product,
      key: product.productId,
      index: index,
      dictionary: dictionary,
      isAccessoriesList: isAccessoriesList,
      lazyLoad: lazyLoad,
      isMobile: isMobile,
      isRouter: true,
      selectedFilters: selectedFilters
    });
  })));
};

var _default = ProductsList;
exports["default"] = _default;